import Vue from 'vue'
import IGTProductBundleBuilder from '../../vue-components/IGTProductBundleBuilder.vue'

const igtApp = new Vue({
    el: "#igt-app-mount",
    components: {
        'igt-product-bundle-builder': IGTProductBundleBuilder
    },
});

// we must attach this app to the window object so we can reference it from the quick view pop up
window.bundleApp = igtApp
